export default function translate(code) {
  return bottlesizes[code];
}

// These conversions are provided by Simon at Berkmann.
const bottlesizes = {
  '000020_0': '2cl',
  '000040_0': '4cl',
  '000050_0': '5cl',
  '000065_0': '6.5cl',
  '000100_0': '10cl',
  '000125_0': '12.5cl',
  '000150_0': '15cl',
  '000187_0': '18.7cl',
  '000180_0': '18cl',
  '000187_5': '18.75cl',
  '000200_0': '20cl',
  '000250_0': '25cl',
  '000275_0': '27.5cl',
  '000300_0': '30cl',
  '000330_0': '33cl',
  '000350_0': '35cl',
  '000355_0': '35.5cl',
  '000375_0': '37.5cl',
  '000440_0': '44cl',
  '000500_0': '50cl',
  '000550_0': '55cl',
  '000568_0': '56.8cl',
  '000600_0': '60cl',
  '000620_0': '62cl',
  '000630_0': '63cl',
  '000640_0': '64cl',
  '000650_0': '65cl',
  '000660_0': '66cl',
  '000700_0': '70cl',
  '000720_0': '72cl',
  '000750_0': '75cl',
  '001000_0': '100cl',
  '001500_0': '150cl',
  '001750_0': '175cl',
  '001800_0': '180cl',
  '001890_0': '189cl',
  '002000_0': '200cl',
  '002250_0': '225cl',
  '003000_0': '300cl',
  '004500_0': '450cl',
  '005000_0': '500cl',
  '006000_0': '600cl',
  '009000_0': '900cl',
  '010000_0': '1000cl',
  '012000_0': '1200cl',
  '015000_0': '1500cl',
  '018000_0': '1800cl',
  '020000_0': '2000cl',
  '030000_0': '3000cl',
  '3x000200_0': '3x20cl',
  '3x000500_0': '3x50cl',
  '3x000050_0': '3x5cl',
  '4x000050_0': '4x5cl',
  '4x000250_0': '4x25cl',
  '4x000330_0': '4x33cl',
  '4x000350_0': '4x35cl',
  '4x000440_0': '4x44cl',
  '4x000500_0': '4x50cl',
  '5x000020_0': '4x2cl',
  '6x000250_0': '6x25cl',
  '6x000275_0': '6x27.5cl',
  '6x000330_0': '6x33cl',
  '6x000500_0': '6x50cl',
  '6x000700_0': '6x70cl',
  '6x000750_0': '6x75cl',
  '6x001500_0': '6x150cl',
  '8x000330_0': '8x33cl',
  '10x000250_0': '10x25cl',
  '10x000330_0': '10x33cl',
  '10x000440_0': '10x44cl',
  '12x000187_0': '12x18.7cl',
  '12x000250_0': '12x25cl',
  '12x000200_0': '12x20cl',
  '12x000275_0': '12x27.5cl',
  '12x000330_0': '12x33cl',
  '12x000355_0': '12x35.5cl',
  '12x000440_0': '12x44cl',
  '15x000440_0': '15x44cl',
  '15x000275_0': '15x27.5cl',
  '15x000300_0': '15x30cl',
  '18x000330_0': '18x33cl',
  '18x000440_0': '18x44cl',
  '24x000350_0': '24x35cl',
};
